import React, { useEffect, useState } from 'react';
import { Button, Form, Input, Alert, Card, Row, Col, Spin } from "antd";

import PropTypes from 'prop-types';
import { hideAuthMessage, loginUser } from 'utils/redux/actions/loginAction';
import { INITIAL_ROUTE_NAME } from 'constants/StorageConstant';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { motion } from "framer-motion"
import { useTranslation } from 'react-i18next';
import { changeLanguage } from 'i18next';

export const LoginForm = props => {

	const { t, i18n } = useTranslation();
	const navigate = useNavigate();
	const dispatch = useDispatch()

	const initialCredential = {
		userName: '',
		password: ''
	}
	const {
		otherSignIn,
		showForgetPassword,
		hideAuthMessageAction,
		showLoading,
		signInWithGoogle,
		signInWithFacebook,
		extra,
		loginUserAction

	} = props

	const [initialLoading, setInitialLoading] = useState(true);
	const loading = useSelector(state => state.loginReducer.loading)
	const isSuccess = useSelector(state => state.loginReducer.isSuccess)
	const errorMessage = useSelector(state => state.loginReducer.errorMessage)
	const showMessage = useSelector(state => state.loginReducer.showMessage)
	const token = useSelector(state => state.loginReducer.token)
	useEffect(() => {
		i18n.changeLanguage(localStorage.getItem('Language') || navigator.language);
		if (token) {
			navigate("/");
		} else {
			setTimeout(() => {
				setInitialLoading(false);
			}, 100);
		}
		if (showMessage) {
			setTimeout(() => {
				dispatch(hideAuthMessage());
			}, 3000);
		}
	}, []);

	useEffect(() => {
		if (isSuccess == true) {
			setTimeout(() => {
				// navigate("/");

				i18n.changeLanguage(localStorage.getItem('Language'));

				window.location.reload();
			}, 150);
		}

	}, [isSuccess]);

	const onLogin = values => {
		dispatch(hideAuthMessage())
		dispatch(loginUser(values));
	};

	if (initialLoading) {
		return (
			<div style={{ width: "fit-content", marginTop: "25%" }} className="mx-auto"><Spin tip="Loading" size="large" spinning={true}></Spin></div>
		);
	}

	const backgroundStyle = {
		backgroundImage: 'url(/img/others/img-17.jpg)',
		backgroundRepeat: 'no-repeat',
		backgroundSize: 'cover'
	}
	return (
		<div className='auth-container'>
			<div className="h-100" style={backgroundStyle}>
				<div className="container d-flex flex-column justify-content-center h-100">
					<Row justify="center">
						<Col xs={20} sm={20} md={20} lg={7}>
							<Card>
								<div className="my-4">
									<div className="text-center">
										<img className="img-fluid" src={`/img/${'logo.png'}`} alt="" />
										<p> </p>
									</div>
									<Row justify="center">
										<Col xs={24} sm={24} md={20} lg={20}>
											<motion.div
												initial={{ opacity: 0, marginBottom: 0 }}
												animate={{
													opacity: showMessage ? 1 : 0,
													marginBottom: showMessage ? 20 : 0
												}}>
												<Alert type="error" showIcon message={(errorMessage)}></Alert>
											</motion.div>
											<Form
												layout="vertical"
												name="login-form"
												initialValues={initialCredential}
												onFinish={onLogin}
											>
												<Form.Item
													name="userName"
													label="Email"
													rules={[
														{
															required: true,
															message: t('WrongEmail'),
														},
														{
															type: 'email',
															message: t('WrongEmailFormat')
														}
													]}>
													<Input prefix className="text-primary" />
												</Form.Item>
												<Form.Item
													name="password"
													label={
														<div className='d-flex justify-content-between w-100 align-items-center'>
															<span>{t('Password')}</span>

														</div>
													}
													rules={[
														{
															required: true,
															message: t('WrongPassword'),
														}
													]}
												>
													<Input.Password prefix className="text-primary" />
												</Form.Item>

												<Form.Item>
													<Button type="primary" htmlType="submit" block loading={loading} >
														{t("Login")}
													</Button>
												</Form.Item>
												<div className='text-right'>
													<Button htmlType='button' href='forgot-pass' className='mr-0 pr-0' type="link">{t("forgotPassword")}</Button>
												</div>
												<div className='text-center mt-2'>
													<a href="https://www.gbmsoft.com/" target="_blank" rel="noopener noreferrer" style={{ color: '#999999' }}>
														Gbm Yazılım
													</a>
												</div>
											</Form>
										</Col>
									</Row>
								</div>
							</Card>
						</Col>
					</Row>
				</div>
			</div>
		</div>

	)
}

LoginForm.propTypes = {
	otherSignIn: PropTypes.bool,
	showForgetPassword: PropTypes.bool,
	extra: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.element
	]),
};

LoginForm.defaultProps = {
	otherSignIn: true,
	showForgetPassword: false
};

export default LoginForm;

